module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option-general', {
    attrs: {
      "value": "interval_until_action",
      "label": _vm.$t('edit.sidebar.interval_until_action')
    }
  }, [_c('div', {
    staticClass: "box-input-group"
  }, [_c('input', {
    staticClass: "box-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.boxConfig.advanced.exibition_frequency_interval_value
    },
    on: {
      "change": function($event) {
        return _vm.boxUpdateConfig({
          item: 'advanced',
          key: 'exibition_frequency_interval_value',
          value: $event.target.value
        });
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "box-input-group-label"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.days')))])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6d48ced8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionfrequency/options/IntervalUntilAction.vue
 ** module id = 853
 ** module chunks = 1
 **/